export const DEFAULT_BLOCK_GAP = 24;
export const DEFAULT_CONTENTS_GROUP_GAP = 32;
export const DEFAULT_CONTENTS_GAP = 16;
export const DEFAULT_LAYOUT_MARGIN_BOTTOM = 0;
